import { DataEntityDisplayOptionEnum } from '..';
import { FieldPresenterModel } from './field-presenter.model';

export class InternalEntityPresenterModel {
  id: string;
  fields: FieldPresenterModel[];
  validation: string;
  specificationVersion: number;
  virtual?: { enabled: boolean; source: string };
  displayOption: DataEntityDisplayOptionEnum;
}
